import React from 'react'
import Main from './Main'

const Users = () => {
  return <Main />
}

export default Users
